module.exports = __webpack_public_path__ + "assets/img/mecha-active-btn-9c9028fc.png";